import type { ReduxState } from '../types/internal/ReduxState';

export default ({ shouldSpeakIncomingActivity }: ReduxState): boolean => shouldSpeakIncomingActivity;
